import { render, staticRenderFns } from "./MailForm.vue?vue&type=template&id=c76b3862&"
import script from "./MailForm.vue?vue&type=script&lang=js&"
export * from "./MailForm.vue?vue&type=script&lang=js&"
import style0 from "./MailForm.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports